<template>
  <a-modal v-model:open="supplierModal.show" :title="supplierModal.title" centered destroyOnClose :getContainer="getContainer" width="800px">
    <a-form :model="supplierModal" :labelCol="{ style: { width: '100px' } }" labelAlign="right" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-form-item>
          <template #label>
            <span style="color: red">*</span>
            <span>供应商名称</span>
          </template>
          <a-textarea v-model:value="supplierModal.name" placeholder="请输入供应商名称" :maxlength="50" :auto-size="{ minRows: 1 }" style="width: 270px" />
        </a-form-item>
        <a-form-item label="供应商简称">
          <a-input v-model:value="supplierModal.short_name" placeholder="请输入供应商简称" :maxlength="50" style="width: 270px" />
        </a-form-item>
      </a-row>
      <a-row>
        <a-form-item label="账户名称">
          <a-input v-model:value="supplierModal.account_name" placeholder="请输入账户名称" :maxlength="50" style="width: 270px" />
        </a-form-item>
        <a-form-item label="开户行">
          <a-input v-model:value="supplierModal.bank_name" placeholder="请输入开户行" :maxlength="50" style="width: 270px" />
        </a-form-item>
      </a-row>
      <a-row>
        <a-form-item label="账号">
          <a-input v-model:value="supplierModal.account" placeholder="请输入账号" :maxlength="50" style="width: 270px" />
        </a-form-item>
        <a-form-item label="联系人">
          <a-input v-model:value="supplierModal.contact_name" placeholder="请输入联系人" :maxlength="50" style="width: 270px" />
        </a-form-item>
      </a-row>
      <a-row>
        <a-form-item label="联系电话">
          <a-input
            :value="supplierModal.contact_phone"
            placeholder="请输入联系电话"
            :maxlength="20"
            @change="(e) => onNumChange(e, supplierModal, 'contact_phone')"
            style="width: 270px"
          />
        </a-form-item>
        <a-form-item label="结算方式">
          <a-select v-model:value="supplierModal.settle_method" :options="settleTypeList" placeholder="请选择结算方式" style="width: 270px"></a-select>
        </a-form-item>
      </a-row>
      <a-button type="link" class="btn-link-success" style="padding: 0" @click="checkTemplate(1)">查看内容标志</a-button>
      <a-form-item label="未发货模板">
        <a-radio-group v-model:value="supplierModal.unship_header_type" @change="supplierModal.unship_header = null">
          <a-radio value="1">默认模板</a-radio>
          <a-radio value="2">
            自定义模板
            <a-button type="link" style="padding: 0; margin-right: 10px" v-if="supplierModal.unship_header" @click="checkTemplate(2)">查看模板</a-button>
            <a-button type="link" class="select-btn" @click="clickSelect('file')" v-if="supplierModal.unship_header_type == 2">
              {{ supplierModal.unship_header ? '更换模板' : '选择模板' }}
            </a-button>
            <span v-if="supplierModal.file" style="font-size: 12px">{{ supplierModal.file.name }}</span>
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="导入发货模板">
        <a-button type="link" style="padding: 0; margin-right: 10px" v-if="supplierModal.import_header" @click="checkTemplate(3)">查看模板</a-button>
        <a-button type="link" style="padding: 0" @click="clickSelect('import_file')">
          {{ supplierModal.import_header ? '更换模板' : '选择模板' }}
        </a-button>
        <span v-if="supplierModal.import_file" style="margin-left: 10px; font-size: 12px">{{ supplierModal.import_file.name }}</span>
      </a-form-item>
      <div v-if="hasAuthority(['24'])">
        <a-form-item label="登录账号">
          <a-input
            v-model:value="supplierModal.login_name"
            placeholder="请输入登录账号"
            :maxlength="50"
            style="width: 270px"
            :disabled="supplierModal.is_login_name"
          />
          <div style="margin-left: 20px; color: red">创建后不可更改，请谨慎填写</div>
        </a-form-item>
        <a-form-item label="登录密码">
          <a-input v-model:value="supplierModal.login_word" placeholder="请输入登录密码" :maxlength="50" style="width: 270px" />
        </a-form-item>
      </div>
    </a-form>
    <input
      class="selectFile"
      type="file"
      @change="selectedFile($event)"
      ref="selectFile"
      accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    />
    <template #footer>
      <a-button type="primary" :loading="supplierModal.loading" @click="saveSupplier">保存</a-button>
    </template>
  </a-modal>

  <a-modal v-model:open="tmplCharModal.show" :title="tmplCharModal.title" centered width="80%" :footer="null" :getContainer="getContainer">
    <div class="char-list">
      <template v-if="tmplCharModal.type === 1">
        <div class="char-item bold">
          <div class="title">内容标志</div>
          <div class="example">示例</div>
        </div>
        <div class="char-item" v-for="item in tmplCharModal.list" :key="item.key">
          <div class="title">
            <span class="title-text" title="点击可复制" @click="copyChar(item.char)">{{ item.char }}</span>
          </div>
          <div class="example">{{ item.example }}</div>
        </div>
      </template>
      <template v-if="tmplCharModal.type === 2 || tmplCharModal.type === 3">
        <div class="char-item" v-for="item in tmplCharModal.templateList" :key="item.header">
          <div class="title">{{ item.header }}</div>
          <div class="example">{{ item.data.join() }}</div>
        </div>
      </template>
    </div>
  </a-modal>
</template>

<script setup>
  import { reactive, ref, toRefs } from 'vue'
  import { saveSupplierInfo, getTradeTmplCharList } from '@/api/project/integralSeckill/manageGoods'
  import { message } from 'ant-design-vue'
  import { copyText, hasAuthority, isNull } from '@/utils'

  const props = defineProps({
    getContainer: {
      type: Function,
      default() {
        return document.body
      },
    },
  })
  const emit = defineEmits(['save'])

  const { getContainer } = toRefs(props)

  const settleTypeList = [
    { value: '款到发货', label: '款到发货' },
    { value: '货到付款', label: '货到付款' },
    { value: '预存贷款', label: '预存贷款' },
    { value: '账期', label: '账期' },
  ]
  const supplierModal = reactive({
    show: false,
    loading: false,
    title: '新增供应商',
    id: '',
    name: '',
    short_name: '',
    account_name: '',
    bank_name: '',
    account: '',
    contact_name: '',
    contact_phone: '',
    settle_method: null,
    unship_header_type: '1',
    file: null,
    import_file: null,
    unship_header: null,
    import_header: null,
    is_login_name: false, //是否已有登录账号（用于禁用）
    login_name: '',
    login_word: '',
  })

  // 新增/编辑供应商
  const setModalForm = (item) => {
    const isEdit = item && item.id
    supplierModal.title = isEdit ? '编辑供应商' : '新增供应商'
    supplierModal.id = isEdit ? item.id : ''
    supplierModal.name = isEdit ? item.name : ''
    supplierModal.short_name = isEdit ? item.short_name : ''
    supplierModal.account_name = isEdit ? item.account_name : ''
    supplierModal.bank_name = isEdit ? item.bank_name : ''
    supplierModal.account = isEdit ? item.account : ''
    supplierModal.contact_name = isEdit ? item.contact_name : ''
    supplierModal.contact_phone = isEdit ? item.contact_phone : ''
    supplierModal.settle_method = isEdit ? (item.settle_method ? item.settle_method : null) : null
    supplierModal.unship_header = isEdit ? item.unship_header : null
    supplierModal.unship_header_type = isEdit ? item.unship_header_type || '1' : '1'
    supplierModal.file = null
    supplierModal.import_header = isEdit ? item.import_header : null
    supplierModal.import_file = null
    supplierModal.login_name = isEdit ? item.user_account : ''
    supplierModal.is_login_name = isNull(supplierModal.login_name) ? false : true
    supplierModal.login_word = isEdit && !isNull(supplierModal.login_name) ? '******' : null
    supplierModal.show = true
  }

  // 保存供应商信息
  const saveSupplier = async () => {
    if (supplierModal.name === '') {
      return message.error('请填写供应商名称')
    }
    if (supplierModal.unship_header_type == 2) {
      if (isNull(supplierModal.unship_header) && isNull(supplierModal.file)) {
        return message.error('请导入未发货模板')
      }
    }
    supplierModal.loading = true
    const body = {
      id: supplierModal.id,
      name: supplierModal.name,
      short_name: supplierModal.short_name,
      account_name: supplierModal.account_name,
      bank_name: supplierModal.bank_name,
      account: supplierModal.account,
      contact_name: supplierModal.contact_name,
      contact_phone: supplierModal.contact_phone,
      settle_method: supplierModal.settle_method ? supplierModal.settle_method : '',
      unship_header_type: supplierModal.unship_header_type,
      user_account: supplierModal.login_name,
      user_password: supplierModal.login_word == '******' ? '' : supplierModal.login_word,
    }
    if (supplierModal.file) {
      body.file = supplierModal.file
      body.upload = true
    }
    if (supplierModal.import_file) {
      body.import_file = supplierModal.import_file
      body.upload = true
    }
    const res = await saveSupplierInfo(body)
    supplierModal.loading = false
    if (res.code === 0) {
      supplierModal.show = false
      emit('save')
      message.success('保存成功')
    } else {
      message.error(res.msg)
    }
  }

  const selectFile = ref(null)
  const selectKey = ref('')
  // 点击选择文件按钮
  const clickSelect = (key) => {
    selectKey.value = key
    selectFile.value.click()
  }
  // 选择文件
  const selectedFile = (e) => {
    if (!selectKey.value) {
      return
    }
    supplierModal[selectKey.value] = e.target.files[0]
    selectFile.value.value = ''
  }

  // 订单模板标志内容查看
  const tmplCharModal = reactive({
    show: false,
    title: '',
    list: [],
    templateList: [],
    type: 1,
  })

  const getTmplCharList = async () => {
    const res = await getTradeTmplCharList()
    if (res.code === 0) {
      tmplCharModal.list = res.data.list
    }
  }

  // 查看模板
  const checkTemplate = (type) => {
    tmplCharModal.type = type
    if (type === 1) {
      tmplCharModal.title = '查看内容标志'
      if (tmplCharModal.list.length === 0) {
        getTmplCharList()
      }
    } else if (type === 2) {
      tmplCharModal.title = '查看未发货模板'
      tmplCharModal.templateList = JSON.parse(supplierModal.unship_header)
    } else if (type === 3) {
      tmplCharModal.title = '查看导入模板'
      tmplCharModal.templateList = JSON.parse(supplierModal.import_header)
      console.log(tmplCharModal.templateList)
    }
    tmplCharModal.show = true
  }

  // 处理数字输入框内容
  const onNumChange = (e, item, key) => {
    const { value } = e.target
    let reg = /^[0-9]*$/
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      item[key] = value
    }
  }

  // 复制内容
  const copyChar = (text) => {
    copyText(text).then(() => {
      message.success('复制成功')
    })
  }

  defineExpose({
    setModalForm,
  })
</script>

<style lang="scss" scoped>
  .select-btn {
    padding: 0;
    margin: 0 10px;
  }
  .selectFile {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    opacity: 0;
    display: none;
  }
  .ant-form-item {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    ::v-deep(.ant-form-item-control-input-content) {
      display: flex;
      align-items: center;
    }
  }

  .char-list {
    display: flex;
    border: 1px solid #c0c0c0;
    width: 100%;
    overflow-x: auto;
    .char-item {
      flex: 1;
      text-align: center;
      &.bold {
        font-weight: bold;
      }
      & + .char-item {
        border-left: 1px solid #c0c0c0;
      }
      .title,
      .example {
        height: 40px;
        line-height: 40px;
        padding: 0 8px;
        white-space: nowrap;
      }
      .title {
        border-bottom: 1px solid #c0c0c0;
        .title-text {
          color: $ehf-color-blue;
          cursor: pointer;
        }
      }
    }
  }
</style>
